export class BaseSanitizer {
    constructor(context, entityType, configKey, enabled = true) {
        this.context = context;
        this.entityType = entityType;
        this.configKey = configKey;
        this.enabled = enabled;
    }
    setEnabled(enabled) {
        this.enabled = enabled;
    }
    isEnabled() {
        return this.enabled;
    }
    sanitize(text) {
        if (!this.enabled) {
            return text;
        }
        const matches = this.detectMatches(text);
        const taggedMatches = matches.map(m => ({
            ...m,
            tag: this.context.getOrCreateTag(this.entityType, m.originalText)
        }));
        return this.replaceMatches(text, taggedMatches);
    }
    replaceMatches(text, matches) {
        if (matches.length === 0) {
            return text;
        }
        let newText = text;
        const replacements = matches.map(m => ({
            start: m.startIndex,
            end: m.endIndex,
            tag: m.tag
        }));
        replacements.sort((a, b) => b.start - a.start);
        for (const replacement of replacements) {
            newText = newText.slice(0, replacement.start) + replacement.tag + newText.slice(replacement.end);
        }
        return newText;
    }
    /**
     * Removes overlapping matches, keeping the first match encountered.
     * Matches are sorted by start index, and overlapping subsequent matches are removed.
     */
    removeOverlappingMatches(matches) {
        if (matches.length === 0) {
            return matches;
        }
        const sorted = [...matches].sort((a, b) => a.startIndex - b.startIndex);
        const result = [];
        for (const match of sorted) {
            const isOverlapping = result.some(m => match.startIndex < m.endIndex && match.endIndex > m.startIndex);
            if (!isOverlapping) {
                result.push(match);
            }
        }
        return result;
    }
}
